<div>
  <mat-tab-group dynamicHeight mat-stretch-tabs style="margin-left: 1%;margin-right: 1%;">
    <mat-tab label="Art Piece Details">
      @if (artPieceData) {
        <div>
          <mat-card>
            @for (data of artPieceData; track data) {
              <div class="tracking">
                <mat-label><span style="font-weight: bold;">Art Number #:</span> {{data.art_number}}</mat-label>
                <mat-label><span style="font-weight: bold;">Division code :</span> {{selectedDivision?.division_name}}</mat-label>
              </div>
            }
          </mat-card>
          <br />
          <div>
            <div class="item-detail-card">
              <div class="image-section">
                @if (artPieceAttachments?.length) {
                  <owl-carousel-o [options]="customOptions">
                    @for (attachment of artPieceAttachments; track attachment) {
                      <ng-template carouselSlide>
                        <div class="slide">
                          <img [src]="attachment.link" [alt]="attachment.file_name">
                          <div class="slide-footer">
                            <div class="image-info">
                              @if (attachment.created_at) {
                                <span class="creation-date">Created: {{ attachment.created_at | date:'medium' }}</span>
                              }
                            </div>
                            <div class="primary-button-container" style="display: flex; gap: 8px;">
                              @if (!attachment.primary_image) {
                                <button mat-raised-button color="primary" (click)="setPrimaryImage(attachment)">Set as Primary</button>
                                <button mat-raised-button color="warn" (click)="deleteImage(attachment)">Delete</button>
                              } @else {
                                <button mat-raised-button color="warn" (click)="deleteImage(attachment)">Delete</button>
                              }
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    }
                  </owl-carousel-o>
                }
                @if (!artPieceAttachments?.length) {
                  <mat-card class="item-detail-img-card image-mat">
                    <p>No images available for this art piece.</p>
                  </mat-card>
                }
                <app-image-upload (uploadComplete)="onUploadComplete($event)" [value]="'image'"></app-image-upload>
              </div>
              <div class="details-container">
                <div class="flex-grow">
                  <button mat-icon-button (click)="editing = !editing" class="edit-button">
                    <mat-icon>{{ editing ? 'close' : 'edit' }}</mat-icon>
                  </button>
                  @if (!editing) {
                    <!-- Read-Only View -->
                    <div class="read-only-container">
                      <mat-card class="read-only-card">
                        <mat-card-content>
                          <div class="details-grid">
                            <div class="read-only-field flex-field">
                              <span class="read-only-label">Art Description</span>
                              <span class="read-only-value">{{ artPieceData[0]?.art_description|| '-' }}</span>
                            </div>
                            @if (artPieceData[0].divisioncode_id !== 9) {
                              <div class="read-only-field flex-field">
                                <span class="read-only-label">Licensor</span>
                                <span class="read-only-value">{{ selectedLicensor?.title || '-' }}</span>
                              </div>
                            }
                            @if (artPieceData[0].divisioncode_id !== 9) {
                              <div class="read-only-field flex-field">
                                <span class="read-only-label">Property</span>
                                <span class="read-only-value">{{ selectedProperty?.title || '-' }}</span>
                              </div>
                            }
                            @if (artPieceData[0].divisioncode_id === 9) {
                              <div class="read-only-field flex-field">
                                <span class="read-only-label">Big Theme</span>
                                <span class="read-only-value">{{ selectedBigTheme?.title || '-' }}</span>
                              </div>
                            }
                            @if (artPieceData[0].divisioncode_id === 9) {
                              <div class="read-only-field flex-field">
                                <span class="read-only-label">Little Theme</span>
                                <span class="read-only-value">{{ selectedLittleTheme?.title || '-' }}</span>
                              </div>
                            }
                            <div class="read-only-field flex-field">
                              <span class="read-only-label">Season</span>
                              <span class="read-only-value">{{ selectedSeason?.seasonDesc || '-' }}</span>
                            </div>
                            @if (artPieceData[0].divisioncode_id !== 9) {
                              <div class="read-only-field flex-field">
                                <span class="read-only-label">Styleguide</span>
                                <span class="read-only-value">{{ selectedStyleguide?.mg_desc || '-' }}</span>
                              </div>
                            }
                            <div class="read-only-field flex-field">
                              <span class="read-only-label">Artist</span>
                              <span class="read-only-value">{{ selectedArtist?.title || '-' }}</span>
                            </div>
                            <div class="read-only-field flex-field">
                              <span class="read-only-label">Age Group</span>
                              <span class="read-only-value">{{ selectedAgeGroup?.title || '-' }}</span>
                            </div>
                            @if (artPieceData[0].divisioncode_id === 9) {
                              <div class="read-only-field flex-field">
                                <span class="read-only-label">Art Type</span>
                                <span class="read-only-value">{{ selectedArtType?.title || '-' }}</span>
                              </div>
                            }
                            <div class="read-only-field flex-field">
                              <span class="read-only-label">Art Source</span>
                              <span class="read-only-value">{{ selectedArtSource?.title || '-' }}</span>
                            </div>
                            <div class="read-only-field flex-field">
                              <span class="read-only-label">Tags</span>
                              <span class="read-only-value">
                                @if (tags?.length) {
                                  <mat-chip-listbox>
                                    @for (t of tags; track t) {
                                      <mat-chip-option class="tag-chip">
                                        {{ t }}
                                      </mat-chip-option>
                                    }
                                  </mat-chip-listbox>
                                } @else {
                                  -
                                }
                              </span>
                            </div>
                          </div>
                        </mat-card-content>
                      </mat-card>
                    </div>
                  } @else {
                    <!-- Editable View -->
                    <div class="edit-container fx-col fx-gap-col-24px">
                      <mat-card>
                        <mat-card-content>
                          <div class="details-grid">
                            <mat-form-field appearance="fill" class="full-width">
                              <mat-label>Art Description</mat-label>
                              <textarea matInput [(ngModel)]="artPieceData[0].art_description" rows="3"></textarea>
                            </mat-form-field>
                            @if (artPieceData[0]?.divisioncode_id !== 9) {
                              <mat-form-field appearance="fill" class="flex-field">
                                <mat-label>Licensor</mat-label>
                                <mat-select [(ngModel)]="selectedLicensor">
                                  @for (option of licensorOptions; track option) {
                                    <mat-option [value]="option">
                                      {{ option.title }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            }
                            @if (artPieceData[0].divisioncode_id !== 9) {
                              <mat-form-field appearance="fill" class="flex-field">
                                <mat-label>Property</mat-label>
                                <mat-select [(ngModel)]="selectedProperty">
                                  @for (option of propertyOptions; track option) {
                                    <mat-option [value]="option">
                                      {{ option.title }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            }
                            @if (artPieceData[0].divisioncode_id === 9) {
                              <mat-form-field appearance="fill" class="flex-field">
                                <mat-label>Big Theme</mat-label>
                                <mat-select [(ngModel)]="selectedBigTheme">
                                  @for (option of bigThemeOptions; track option) {
                                    <mat-option [value]="option">
                                      {{ option.title }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            }
                            @if (artPieceData[0].divisioncode_id === 9) {
                              <mat-form-field appearance="fill" class="flex-field">
                                <mat-label>Little Theme</mat-label>
                                <mat-select [(ngModel)]="selectedLittleTheme">
                                  @for (option of littleThemeOptions; track option) {
                                    <mat-option [value]="option">
                                      {{ option.title }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            }
                            <mat-form-field appearance="fill" class="flex-field">
                              <mat-label>Season</mat-label>
                              <mat-select [(ngModel)]="selectedSeason">
                                @for (option of seasonptions; track option) {
                                  <mat-option [value]="option">
                                    {{ option.seasonDesc }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="flex-field">
                              <mat-label>Styleguide</mat-label>
                              <mat-select [(ngModel)]="selectedStyleguide">
                                @for (option of styleguidOptions; track option) {
                                  <mat-option [value]="option">
                                    {{ option.title }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="flex-field">
                              <mat-label>Artist</mat-label>
                              <mat-select [(ngModel)]="selectedArtist">
                                @for (option of artistOptions; track option) {
                                  <mat-option [value]="option">
                                    {{ option.title }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                            <mat-form-field appearance="fill" class="flex-field">
                              <mat-label>Adult Or Juvenile</mat-label>
                              <mat-select [(ngModel)]="selectedAgeGroup">
                                @for (option of ageGroupOptions; track option) {
                                  <mat-option [value]="option">
                                    {{ option.title }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                            @if (artPieceData[0].divisioncode_id === 9) {
                              <mat-form-field appearance="fill" class="flex-field">
                                <mat-label>Art Type</mat-label>
                                <mat-select [(ngModel)]="selectedArtType">
                                  @for (option of artTypeOptions; track option) {
                                    <mat-option [value]="option">
                                      {{ option.title }}
                                    </mat-option>
                                  }
                                </mat-select>
                              </mat-form-field>
                            }
                            <mat-form-field appearance="fill" class="flex-field">
                              <mat-label>Art Source</mat-label>
                              <mat-select [(ngModel)]="selectedArtSource">
                                @for (option of artSourceOptions; track option) {
                                  <mat-option [value]="option">
                                    {{ option.title }}
                                  </mat-option>
                                }
                              </mat-select>
                            </mat-form-field>
                            <!-- Tags (keywords) -->
                            <mat-form-field appearance="fill" class="full-width">
                              <mat-label>Tags (keywords)</mat-label>
                              <mat-chip-grid #chipList aria-label="Art tags">
                                @for (t of tags; track t) {
                                  <mat-chip-row
                                    [removable]="true"
                                    class="tag-chip"
                                    (removed)="removeTag(t)">
                                    {{ t }}
                                    <button matChipRemove aria-label="Remove tag">
                                      <mat-icon>close</mat-icon>
                                    </button>
                                  </mat-chip-row>
                                }
                                <input
                                  placeholder="Add tag and press ENTER"
                                  [matChipInputFor]="chipList"
                                  [matChipInputSeparatorKeyCodes]="separatorKeysCodes"
                                  (matChipInputTokenEnd)="addTag($event)"/>
                                </mat-chip-grid>
                              </mat-form-field>
                              <!-- Add other form fields as necessary -->
                            </div>
                          </mat-card-content>
                        </mat-card>
                        <div class="action-buttons" align="end">
                          <button mat-stroked-button (click)="editing = false" class="mr-2">Cancel</button>
                          <button mat-raised-button color="primary" (click)="onSave()">Save</button>
                        </div>
                      </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </mat-tab>
      <mat-tab label="Linked Items">
        <div class="linked-items-container">
          @if (relatedItems && relatedItems.length > 0) {
            @for (item of relatedItems; track item) {
              <mat-card class="linked-item-card" (click)="goToItem(item.item_id_pk)">
                <mat-card-header>
                  <mat-card-title>{{ item.item_descr_name }}</mat-card-title>
                </mat-card-header>
                @if (getPrimaryImage(item)) {
                  <img mat-card-image [src]="getPrimaryImage(item)" alt="Photo of an item">
                }
              </mat-card>
            }
          } @else {
            <mat-card class="no-items-card">
              <mat-card-content>
                <p>No items have been created from this art piece yet.</p>
              </mat-card-content>
            </mat-card>
          }
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>